import React from 'react';
import { FixedFooter } from 'components/common/FixedFooter';
import styles from './SaveFixedFooter.scss';
import { Button, BUTTON} from 'components/common/Button/Button';

export default (props) => (
    <FixedFooter className={styles.fixedFooter}>
        <div className={styles.saveButtonContainer} data-cy="FixedFooters">
            <Button 
                className={styles.saveButton}
                disabled={props.disabled}
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                onClick={props.onClick}
                data-cy="FixedFooters-Button">
                {props.children}
            </Button>
        </div>
    </FixedFooter>
);
